import { ErrorBoundary as BaseErrorBoundary, ErrorBoundaryProps } from '@orbis-systems/orbis-react-toolkit';
import * as Sentry from '@sentry/react';
import React from 'react';

export const ErrorBoundary: React.FunctionComponent<ErrorBoundaryProps> = (props) => {
    return (
        <BaseErrorBoundary
            {...props}
            onCatch={(error, errorInfo) => {
                const errorId = Sentry.captureException(error);
                Sentry.setExtra('error.info', errorInfo);
                return errorId;
            }}
        />
    );
};
